export const feature_array = [
  {
    id: 1,
    //icon: "uil uil-airplay h2 text-primary",
    title: "Intuitive dashboard",
    description: "Provides quick, actionable insights"
    // imgUrl: img1,
  },
  {
    id: 2,
    //icon: "uil uil-calendar-alt h2 text-primary",
    title: "Easy team management",
    description: "Manage Users Effortlessly.Invite your team members.Manage access and monitor activity."
    //imgUrl: calendar,
  },
  {
    id: 3,
    // icon: "uil uil-clock h2 text-primary",
    title: "Statistics and Logs",
    description: "View recent agent and customer activity.Track visitors and interactions for timely follow-up"
    // imgUrl: sandClock,
  }
];











